<template>
    <div class="page-content">
        <div class="page-head">
            <div class="page-head-content">
                <el-select v-model="searchForm.sort">
                    <el-option v-for="(item,index) in sort_type" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <el-input style="margin-left: auto;width: 300px;" clearable v-model="searchForm.address">
                    <template slot="prepend">目的地</template>
                    <el-button slot="append" type="primary" icon="el-icon-search" @click="clickSearch"></el-button>
                </el-input>
            </div>
        </div>
        <div class="card-content">
            <HouseCard showAddress v-for="(item, index) in list" :key="index" :item="item"></HouseCard>
            <el-alert v-if="list.length<=0" title="暂无相关数据~" class="mt-20" center :closable="false" type="warning" show-icon></el-alert>
        </div>
        <div v-if="!finish" class="load-content">上拉加载更多 <i class="el-icon-loading"></i></div>
    </div>
</template>

<script>
    import HouseCard from "@/components/HouseCard";
    import {mapState} from 'vuex'
    export default {
        name: "searchHouse",
        components: {HouseCard},
        data(){
            return {
                list: [],
                sort_type:[
                    {id: 1, name: '评价由低到高'},
                    {id: 2, name: '评价由高到低'},
                    {id: 3, name: '价格由高到低'},
                    {id: 4, name: '价格由低到高'}
                ],
                searchForm:{
                    page: 1,
                    address: '',
                    sort: 1,
                    nums: 12
                },
                finish: false
            }
        },
        created(){
            let {key} = this.$route.query;
            this.searchForm.address = key;
            this.getLandlord();
            this.$eventBus.$on('onBottom', this.handlerBottom)
        },
        beforeDestroy(){
            this.$eventBus.$off('onBottom', this.handlerBottom)
        },
        watch:{
            'searchForm.sort'(){
                this.clickSearch();
            }
        },
        computed:{
            ...mapState(['cityList'])
        },
        methods:{
            clickSearch(){
                this.searchForm.page = 1;
                this.getLandlord();
            },
            async getLandlord(){
                let [e, data] = await this.$api.getLandlordApi(this.searchForm)
                if(e) return;
                if(data.code === 200){
                    if(this.searchForm.page === 1){
                        this.list = data.result.house;
                    }else {
                        this.list =[...this.list, ...data.result.house];
                    }
                    this.finish = data.result.house.length < this.searchForm.nums;
                }
            },
            handlerBottom(){
                if(this.finish) return;
                this.searchForm.page++;
                this.getLandlord();
            }
        }
    }
</script>

<style scoped lang="less">
    .page-head{
        width: 100%;
        height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #ffffff;
        position: sticky;
        top: 80px;
        left: 0;
        z-index: 10;
        border-bottom: solid 1px #e2e2e2;
        .page-head-content{
            width: 1200px;
            height: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
    }
    .card-content{
        display: flex;
        width: 1200px;
        min-height: 400px;
        margin: auto;
        justify-content: flex-start;
        align-items: flex-start;
        align-content: flex-start;
        flex-wrap: wrap;
    }
</style>
